import { IApplicationState } from '../../types/redux';
import { getOffices } from './getOffices';

export function checkOffices(state: IApplicationState) {
  const offices = getOffices(state);

  return Boolean(offices.list.length);
}
